import {Component, Input} from '@angular/core';
import {ViewBreakpointService} from '@common-module/app-services/view-breakpoint.service';
import { NgClass, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-info-card',
    templateUrl: './info-card.component.html',
    styleUrls: ['../carousel-card-styles.component.scss'],
    imports: [NgClass, AsyncPipe]
})

export class InfoCardComponent {

 @Input() width: number;

  constructor(public viewBreakpointService: ViewBreakpointService) { }
}
